import * as React from 'react';
import { Colors } from './colors';

export enum HatchPatternId {
  Disputable = 'pattern-disputable-diagonal-hatch',
  NonDisputable = 'pattern-non-disputable-diagonal-hatch',
}

export const getHatchPatternFill = (id: HatchPatternId): string => {
  return `url(#${id})`;
};

const HatchPattern: React.FC<{ id: string; color: string }> = ({ id, color }) => {
  return (
    <pattern
      id={id}
      width="5"
      height="5"
      patternUnits="userSpaceOnUse"
      patternTransform="translate(0, 0) rotate(110) skewX(0)"
    >
      <svg width="5" height="5" viewBox="0 0 100 100">
        <rect x="0" y="0" width="100%" height="100%" fill={color} />
        <g fill="#FFFFFF" opacity="1">
          <rect width="20" height="100" y="60" transform="rotate(-90 0 60)" />
        </g>
      </svg>
    </pattern>
  );
};

/**
 * This component does not render anything directly, but does make these
 * patterns available to other components using the `getHatchPatternFill` function.
 */
export const Patterns: React.FC = () => {
  return (
    <svg style={{ height: 0, width: 0, position: 'absolute' }}>
      <defs>
        <HatchPattern id={HatchPatternId.Disputable} color={Colors.Disputable} />
        <HatchPattern id={HatchPatternId.NonDisputable} color={Colors.NonDisputable} />
      </defs>
    </svg>
  );
};
HatchPattern.displayName = 'Shipments.Historical.HatchPattern';
